import { render, staticRenderFns } from "./ErrorLayout.vue?vue&type=template&id=7446c788&"
import script from "./ErrorLayout.vue?vue&type=script&lang=js&"
export * from "./ErrorLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports